/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConfiguredActionItemDto } from './configuredActionItemDto';
import { EquipmentItemDto } from './equipmentItemDto';
import { TextBlockItemDto } from './textBlockItemDto';


export interface AssessmentPresetDetailDto { 
    id: string;
    text: string;
    basis?: string;
    referenceWork?: string;
    textBlocks: Array<TextBlockItemDto>;
    action?: ConfiguredActionItemDto;
    checkpointId: string;
    checkInterval: AssessmentPresetDetailDto.CheckIntervalEnum;
    buildingEquipmentRelated: boolean;
    standardAssessment: boolean;
    standardEquipment?: EquipmentItemDto;
    deprecated: boolean;
}
export namespace AssessmentPresetDetailDto {
    export type CheckIntervalEnum = 'YEAR' | 'HALF_YEAR' | 'ONE_MONTH' | 'NONE' | 'TEN_DAYS';
    export const CheckIntervalEnum = {
        Year: 'YEAR' as CheckIntervalEnum,
        HalfYear: 'HALF_YEAR' as CheckIntervalEnum,
        OneMonth: 'ONE_MONTH' as CheckIntervalEnum,
        None: 'NONE' as CheckIntervalEnum,
        TenDays: 'TEN_DAYS' as CheckIntervalEnum
    };
}


